import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const GuaranteeIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 14 16"
  >
    <path
      fillRule="evenodd"
      d="M6.837.268a.75.75 0 0 1 .326 0l6 1.333a.75.75 0 0 1 .587.732v6c0 2.69-1.732 4.552-3.31 5.692a13.4 13.4 0 0 1-3.119 1.657q-.038.014-.059.02l-.017.007-.005.002h-.002L7 15l-.238.711H6.76l-.005-.002-.017-.006-.059-.02-.209-.079a13.39 13.39 0 0 1-2.91-1.58C1.983 12.885.25 11.023.25 8.335v-6A.75.75 0 0 1 .837 1.6zM7 15l-.238.711c.154.052.321.052.475 0zm0-.8a11.89 11.89 0 0 0 2.56-1.392c1.422-1.026 2.69-2.497 2.69-4.475V2.935L7 1.768 1.75 2.935v5.398c0 1.978 1.268 3.45 2.69 4.476A12 12 0 0 0 7 14.2"
      clipRule="evenodd"
    />
    <path d="M6.71 3.45v.77a2.9 2.9 0 0 0-1.59.568 1.49 1.49 0 0 0-.57 1.197c-.013.418.134.825.412 1.138.4.385.882.676 1.409.851l.336.13v1.557a5.6 5.6 0 0 1-1.097-.196 6 6 0 0 1-1.05-.381v1.325c.68.285 1.41.431 2.149.432v1.009h.687v-1.029a2.87 2.87 0 0 0 1.617-.58 1.59 1.59 0 0 0 .578-1.283 1.5 1.5 0 0 0-.196-.77 1.9 1.9 0 0 0-.607-.608 7.7 7.7 0 0 0-1.394-.652V5.444c.554.047 1.097.179 1.61.39l.472-1.174a5.7 5.7 0 0 0-2.08-.462V3.45zm0 3.193q-.271-.107-.495-.294a.48.48 0 0 1-.154-.364q0-.426.648-.522zm.687 1.732q.276.117.512.302a.45.45 0 0 1 .171.356q0 .477-.683.592z" />
  </svg>
);
GuaranteeIcon.id = 'GuaranteeIcon';
GuaranteeIcon.displayName = 'GuaranteeIcon';
export default GuaranteeIcon;
